import type { SavedFilter } from 'Types/savedFilter';

export const NAME_MAX_LENGTH = 25;

export const NAME_ERRORS = {
	DUPLICATE: 'nameErrorDuplicate',
	MAX_LENGTH: 'nameErrorMaxLength',
} as const;

export type NameError = (typeof NAME_ERRORS)[keyof typeof NAME_ERRORS];

interface ValidateNameArgs {
	excludeName?: string;
	name: string;
	savedFilters: SavedFilter[];
}

export const validateSavedSearchName = ({ excludeName, name, savedFilters }: ValidateNameArgs): Nullable<NameError> => {
	const trimmed = name.trim();

	if (trimmed.length > NAME_MAX_LENGTH) {
		return NAME_ERRORS.MAX_LENGTH;
	}

	const isDuplicate = savedFilters.some((filter) => filter.name === trimmed && trimmed !== excludeName);

	if (isDuplicate) {
		return NAME_ERRORS.DUPLICATE;
	}

	return null;
};
